import { render, staticRenderFns } from "./ClinicsComponent.vue?vue&type=template&id=b9535b08&scoped=true"
import script from "./ClinicsComponent.vue?vue&type=script&lang=js"
export * from "./ClinicsComponent.vue?vue&type=script&lang=js"
import style0 from "./ClinicsComponent.vue?vue&type=style&index=0&id=b9535b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9535b08",
  null
  
)

export default component.exports